import {
  CHART_PERIOD_RELATIVE,
  CHART_TERM_TYPE,
  CHART_TERM_UNIT,
} from '@/entities/chart/model/constants';

import type {
  TemplateDateTermInput,
  TemplateFixedDateTermInput,
  TemplatePeriodicDateTermInput,
  TemplatePeriodicTermUnit,
} from './types';

const TEMPLATE_PERIODIC_TERM_MAX_VALUE_MAP: Record<TemplatePeriodicTermUnit, number> =
  {
    [CHART_TERM_UNIT.DAY]: 90,
    [CHART_TERM_UNIT.WEEK]: 12,
    [CHART_TERM_UNIT.MONTH]: 3,
    [CHART_TERM_UNIT.QUARTER]: 1,
  };

export const TEMPLATE_PERIODIC_TERM_UNITS: TemplatePeriodicTermUnit[] = [
  CHART_TERM_UNIT.DAY,
  CHART_TERM_UNIT.WEEK,
  CHART_TERM_UNIT.MONTH,
  CHART_TERM_UNIT.QUARTER,
];

export const TEMPLATE_PERIODIC_TERM_RELATIVES = [
  CHART_PERIOD_RELATIVE.INCLUDE,
  CHART_PERIOD_RELATIVE.EXCLUDE,
] as const;

export const getTemplatePeriodicTermMaxValue = (
  unit: TemplatePeriodicTermUnit,
): number => TEMPLATE_PERIODIC_TERM_MAX_VALUE_MAP[unit];

export const createDefaultTemplateFixedDateTerm = (): TemplateFixedDateTermInput => ({
  type: CHART_TERM_TYPE.FIXED,
  startDate: '',
  endDate: '',
});

export const createDefaultTemplatePeriodicDateTerm =
  (): TemplatePeriodicDateTermInput => ({
    type: CHART_TERM_TYPE.PERIODIC,
    unit: CHART_TERM_UNIT.DAY,
    relative: CHART_PERIOD_RELATIVE.INCLUDE,
    value: 3,
  });

export const createDefaultTemplateDateTerm = (): TemplateDateTermInput =>
  createDefaultTemplateFixedDateTerm();

